<template>
  <Layout>
    <div class="row">
      <div class="col-md-12" v-if="Object.keys(trainee).length !== 0">
        <b-card>
          <div class="text-center">
            <h3>Training Activities For Family Members Affected in Land Acquisition at Payra Port</h3>
            <h5>Kalapara, Patuakhali</h5>
            <h5>Checklist For Submission of Required Certificates / Papers by The Trainees</h5>
          </div>
          <div class="form-row mt-5">
            <div class="col-md-6">
              <strong>Trainee Name : </strong> {{ trainee.name }}
            </div>
            <div class="col-md-6">
              <strong>Batch : </strong> Trade : {{ trainee.desc }} - Batch No. : {{ trainee.batch_no }}
            </div>
          </div>
          <div class="form-row mt-2">
            <div class="col-md-6">
               <strong>Form number : </strong>  <span class="box"
                   :style="index + 1 == getFromNo(trainee.form_no).length ? '{border-right-color: rgb(0, 0, 0); border-right-style: solid;border-right-width: 1px;}' : ''"  v-for="(value, index) in getFromNo(trainee.form_no)" :key="index">{{ value }}

            </span>
            </div>
          </div>
        </b-card>
        <b-card>
          <table class="table table-centered table-striped table-bordered">
            <thead>
            <tr>
              <th rowspan="2">Sl</th>
              <th rowspan="2">Certificate / Paper Details</th>
              <th colspan="2">Receipt status</th>
              <th rowspan="2">Comments</th>
            </tr>
            <tr>
              <th>Yes(<i class="mdi mdi-check text-success"></i>)</th>
              <th>No(<i class="mdi mdi-close text-danger"></i>)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(file_tracking, index) in file_trackings" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{file_tracking.desc}}</td>
              <td>
                 <span v-if="file_tracking.trainee_doc">
                   <i class="mdi mdi-check text-success"></i>
                 </span>
              </td>
              <td>
                <span v-if="file_tracking.trainee_doc == null">
                   <i class="mdi mdi-close text-danger"></i>
                 </span>
              </td>
              <td>
                <span v-if="file_tracking.trainee_doc">
                   {{file_tracking.trainee_doc.remarks}}
                </span>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="float-right">
            <table class="table table-borderless">
              <tbody>
              <tr class="text-center">
                <td><br><br><br>
                  <p style="color: gray; margin-bottom: 0px !important">--------------------------------------------------------------------------------------</p>
                  <b>Signature and name of the implementing worker payra project-DORP</b></td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "File Tracking",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "File Tracking",
      items: [
        {
          text: "trainee",
          href: "trainee/files"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      trainee_id: "",
      trainee: {},
      file_trackings: [],
      validation_errors: {},
      show: false
    };
  },
  mounted() {
    this.trainee_id = this.$route.params.trainee_id;
    this.getFileTracking();
    this.getTrainee();
  },
  methods: {
    getFileTracking() {
      let trainee_id = this.$route.params.trainee_id;
      http
          .get("api/trainee/getFiles/" + trainee_id)
          .then(response => {
            this.file_trackings = response.data.file_trackings;

          })
          .catch();
    },
    getTrainee() {
      let trainee_id = this.$route.params.trainee_id;

      http.get("api/trainee/" + trainee_id).then(response => {
        if (!response.data.error) {
          this.trainee = response.data.trainee;
        }
      });
    },
    getFromNo(number){
      var output = []
      var sNumber = number.toString();

      for (var i = 0, len = sNumber.length; i < len; i += 1) {
        output.push(+sNumber.charAt(i));
      }
      return output;
    }
  },


};
</script>
<style>
.box {
  width: 50px;
  height: 50px;
  padding: 5px;
  border-top-color: rgb(0, 0, 0);
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-color: rgb(0, 0, 0);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-left-color: rgb(0, 0, 0);
  border-left-style: solid;
  border-left-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
}
</style>
